export const isDarkTheme = (param: string) => {
  if (param === 'dark') {
    return true;
  }
  return false;
};
